var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavbarLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.981 9.95556C17.7252 15.258 13.4078 19.7488 13.4078 19.8841C13.4078 20.0464 17.7252 24.5101 23.0078 29.8396L32.6078 39.4976H40.1698C46.2302 39.4976 47.7319 39.4164 47.7319 39.1459C47.7319 38.9565 43.495 34.5469 38.3464 29.3527L28.9609 19.8841L38.3464 10.4155C43.495 5.22126 47.7319 0.784543 47.7319 0.595171C47.7319 0.351693 46.0157 0.270533 40.143 0.270533H32.581L22.981 9.95556Z",
    fill: "#273979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17542 25.3758L0.0268156 30.7053L0 43.2039V55.7295H18.5564H37.1129L42.3687 50.5353C45.238 47.6676 47.6246 45.1517 47.6782 44.9623C47.7855 44.5836 45.9888 44.5295 25.2067 44.5295L11.1285 44.5024L11.048 32.2473C10.9944 22.7246 10.914 20.0193 10.6458 20.0193C10.4849 20.0464 8.01788 22.4541 5.17542 25.3758Z",
    fill: "#273979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLight);
export default __webpack_public_path__ + "static/media/navbar-light.2bac5893a53ab961abd10f07494e6037.svg";
export { ForwardRef as ReactComponent };